import type { inbox as en } from "../en/inbox";
import type { Messages } from "../types";

export const inbox: Messages<typeof en> = {
  title: "صندوق الوارد",
  searchPlaceholder: "ابحث في التعليقات والرسائل…",
  semantic: "بحث ذكي",
  semanticHint: "يبحث بالمعنى لا بالكلمات فقط: «زعلان من التوصيل» يجد شكاوى تأخر الطلبات.",
  smartSearch: {
    unavailable: "البحث الذكي غير متاح حاليًا",
    unavailableHint: "نعرض نتائج الكلمات المطابقة فقط. سيعود البحث بالمعنى عندما يعمل فهرس البحث من جديد.",
    degraded: "البحث الذكي متاح جزئيًا",
    degradedHint: "تعذّرت فهرسة بعض الرسائل حتى الآن، لذا قد تكون نتائج البحث بالمعنى ناقصة. نتائج الكلمات المطابقة كاملة.",
  },
  filters: {
    title: "التصفية",
    show: "إظهار التصفية",
    hide: "إخفاء التصفية",
    state: "الحالة",
    type: "النوع",
    typeAll: "الكل",
    typeComment: "التعليقات",
    typeConversation: "الرسائل",
    channel: "القناة",
    account: "الحساب",
    intent: "النية",
    sentiment: "المشاعر",
    assignee: "المسؤول",
    assigneeAnyone: "أي شخص",
    assigneeMe: "المُسندة لي",
    assigneeUnassigned: "غير مُسندة",
    any: "الكل",
    clear: "مسح التصفية",
    active_zero: "{{count}} مفعّلة",
    active_one: "{{count}} مفعّلة",
    active_two: "{{count}} مفعّلة",
    active_few: "{{count}} مفعّلة",
    active_many: "{{count}} مفعّلة",
    active_other: "{{count}} مفعّلة",
    views: "طرق عرض",
    viewAll: "كل المفتوح",
    viewMine: "الخاصة بي",
    viewUnassigned: "غير المُسندة",
    viewNegative: "تحتاج عناية",
    aiCategory: "فئة ذكاء اصطناعي",
    groupWhat: "ماذا",
    groupAi: "الذكاء الاصطناعي",
    groupTeam: "الفريق",
    groupAlso: "إظهار أيضاً",
    onePerson: "شخص واحد",
  },
  list: {
    label: "المحادثات والتعليقات",
    empty: "صندوق فارغ 🎉",
    emptyHint: "لا شيء يطابق هذه التصفية. تظهر التعليقات والرسائل الجديدة هنا مباشرة.",
    emptyFiltered: "لا نتائج",
    emptyFilteredHint: "جرّب إزالة إحدى التصفيات أو البحث عن شيء آخر.",
    newItems_zero: "{{count}} جديد",
    newItems_one: "{{count}} جديد",
    newItems_two: "{{count}} جديد",
    newItems_few: "{{count}} جديد",
    newItems_many: "{{count}} جديد",
    newItems_other: "{{count}} جديد",
    loadingMore: "جارٍ تحميل المزيد…",
    end: "وصلت إلى النهاية",
    hidden: "مخفي",
    deleted: "محذوف",
    voiceNote: "رسالة صوتية",
    photo: "صورة",
    sharedPost: "شارك منشوراً",
    attachment: "مرفق",
    you: "أنت: ",
    comment: "تعليق",
    dm: "رسالة",
    unread: "غير مقروء",
    select: "تحديد {{name}}",
    replies_zero: "لا ردود",
    replies_one: "رد واحد",
    replies_two: "ردّان",
    replies_few: "{{count}} ردود",
    replies_many: "{{count}} ردًا",
    replies_other: "{{count}} رد",
    selectAll: "تحديد كل المحمّل",
    tools: "البحث والتصفية",
    more: "خيارات القائمة",
    smartOn: "تشغيل البحث الذكي",
    smartOff: "إيقاف البحث الذكي",
    smartPlaceholder: "ابحث بالمعنى…",
    compactRows: "صفوف مدمجة",
    comfortableRows: "صفوف مريحة",
  },
  bulk: {
    selected_zero: "{{count}} محدد",
    selected_one: "{{count}} محدد",
    selected_two: "{{count}} محدد",
    selected_few: "{{count}} محدد",
    selected_many: "{{count}} محدد",
    selected_other: "{{count}} محدد",
    hide: "إخفاء",
    unhide: "إظهار",
    done: "تم",
    assign: "إسناد",
    reply: "رد على الكل",
    delete: "حذف",
    replyPlaceholder: "رد واحد لكل التعليقات المحددة…",
    replySend: "إرسال الردود",
    running_zero: "جارٍ تطبيق «\u2068{{action}}\u2069» على {{count}} تعليق",
    running_one: "جارٍ تطبيق «\u2068{{action}}\u2069» على تعليق واحد",
    running_two: "جارٍ تطبيق «\u2068{{action}}\u2069» على تعليقين",
    running_few: "جارٍ تطبيق «\u2068{{action}}\u2069» على {{count}} تعليقات",
    running_many: "جارٍ تطبيق «\u2068{{action}}\u2069» على {{count}} تعليقًا",
    running_other: "جارٍ تطبيق «\u2068{{action}}\u2069» على {{count}} تعليق",
    finished: "تم: {{action}}",
    deleteTitle_zero: "حذف {{count}} تعليق من إنستغرام؟",
    deleteTitle_one: "حذف تعليق واحد من إنستغرام؟",
    deleteTitle_two: "حذف تعليقين من إنستغرام؟",
    deleteTitle_few: "حذف {{count}} تعليقات من إنستغرام؟",
    deleteTitle_many: "حذف {{count}} تعليقًا من إنستغرام؟",
    deleteTitle_other: "حذف {{count}} تعليق من إنستغرام؟",
    onlyComments: "الإجراءات الجماعية تُطبّق على التعليقات فقط، وتُتجاوز الرسائل.",
    undoable: {
      hide: { running_zero: "جارٍ إخفاء {{count}} تعليق", running_one: "جارٍ إخفاء تعليق واحد", running_two: "جارٍ إخفاء تعليقين", running_few: "جارٍ إخفاء {{count}} تعليقات", running_many: "جارٍ إخفاء {{count}} تعليقًا", running_other: "جارٍ إخفاء {{count}} تعليق", done_zero: "تم إخفاء {{count}} تعليق", done_one: "تم إخفاء تعليق واحد", done_two: "تم إخفاء تعليقين", done_few: "تم إخفاء {{count}} تعليقات", done_many: "تم إخفاء {{count}} تعليقًا", done_other: "تم إخفاء {{count}} تعليق" },
      unhide: { running_zero: "جارٍ إظهار {{count}} تعليق", running_one: "جارٍ إظهار تعليق واحد", running_two: "جارٍ إظهار تعليقين", running_few: "جارٍ إظهار {{count}} تعليقات", running_many: "جارٍ إظهار {{count}} تعليقًا", running_other: "جارٍ إظهار {{count}} تعليق", done_zero: "تم إظهار {{count}} تعليق", done_one: "تم إظهار تعليق واحد", done_two: "تم إظهار تعليقين", done_few: "تم إظهار {{count}} تعليقات", done_many: "تم إظهار {{count}} تعليقًا", done_other: "تم إظهار {{count}} تعليق" },
      archive: { running_zero: "جارٍ أرشفة {{count}} تعليق", running_one: "جارٍ أرشفة تعليق واحد", running_two: "جارٍ أرشفة تعليقين", running_few: "جارٍ أرشفة {{count}} تعليقات", running_many: "جارٍ أرشفة {{count}} تعليقًا", running_other: "جارٍ أرشفة {{count}} تعليق", done_zero: "تمت أرشفة {{count}} تعليق", done_one: "تمت أرشفة تعليق واحد", done_two: "تمت أرشفة تعليقين", done_few: "تمت أرشفة {{count}} تعليقات", done_many: "تمت أرشفة {{count}} تعليقًا", done_other: "تمت أرشفة {{count}} تعليق" },
      unarchive: { running_zero: "جارٍ استعادة {{count}} تعليق", running_one: "جارٍ استعادة تعليق واحد", running_two: "جارٍ استعادة تعليقين", running_few: "جارٍ استعادة {{count}} تعليقات", running_many: "جارٍ استعادة {{count}} تعليقًا", running_other: "جارٍ استعادة {{count}} تعليق", done_zero: "تمت استعادة {{count}} تعليق", done_one: "تمت استعادة تعليق واحد", done_two: "تمت استعادة تعليقين", done_few: "تمت استعادة {{count}} تعليقات", done_many: "تمت استعادة {{count}} تعليقًا", done_other: "تمت استعادة {{count}} تعليق" },
    },
    undo: "تراجع",
    undoStarted: "جارٍ التراجع… تُستعاد فقط التعليقات التي غيّرها هذا الإجراء",
    undoFailed: "تعذّر التراجع",
    tag: "وسم",
    untag: "إزالة الوسم",
    deleteMore: "حذف…",
    doneToast_zero: "لم يُنهَ أي عنصر",
    doneToast_one: "تم إنهاء عنصر واحد",
    doneToast_two: "تم إنهاء عنصرين",
    doneToast_few: "تم إنهاء {{count}} عناصر",
    doneToast_many: "تم إنهاء {{count}} عنصرًا",
    doneToast_other: "تم إنهاء {{count}} عنصر",
    assignedToast_zero: "لم يُسند أي عنصر إلى {{name}}",
    assignedToast_one: "أُسند عنصر واحد إلى {{name}}",
    assignedToast_two: "أُسند عنصران إلى {{name}}",
    assignedToast_few: "أُسندت {{count}} عناصر إلى {{name}}",
    assignedToast_many: "أُسند {{count}} عنصرًا إلى {{name}}",
    assignedToast_other: "أُسند {{count}} عنصر إلى {{name}}",
  },
  detail: {
    empty: "اختر محادثة",
    label: "العنصر المحدد",
    emptyHint: "اختر تعليقاً أو رسالة لقراءة السلسلة ورؤية اقتراحات الذكاء الاصطناعي والرد.",
    back: "العودة للقائمة",
    onPost: "تعليق على منشور",
    viewOnInstagram: "عرض على إنستغرام",
    postUnavailable: "معاينة المنشور غير متاحة",
    thread: "السلسلة",
    noReplies: "لا ردود بعد",
    byAccount: "ردّك",
    hiddenNotice: "هذا التعليق مخفي. لا يراه إلا كاتبه ومتابعوه.",
    deletedNotice: "تم حذف هذا التعليق.",
    labels: "الفئات الذكية",
    confidence: "الثقة: {{level}}",
    toxicity: "الإساءة: {{level}}",
    language: "اللغة",
    receivedAt: "وصل",
    assignedTo: "مُسند إلى {{name}}",
    unassigned: "غير مُسند",
    assignTo: "إسناد إلى…",
    assignMe: "إسناد لي",
    unassign: "إلغاء الإسناد",
    deleteConfirm: "حذف هذا التعليق من إنستغرام؟",
    deleteHint: "سيُزال من المنشور للجميع. الإخفاء قابل للتراجع، أما الحذف فلا.",
    more: "إجراءات أخرى",
    openPost: "فتح المنشور",
    why: {
      link: "لماذا هذا التصنيف؟",
      title: "لماذا صنّفته منصة ملفك هكذا",
      intent: "الموضوع",
      sentiment: "المشاعر",
      sure: "مدى التأكد",
      toxicity: "الإساءة",
      language: "اللغة",
      low: "منخفضة",
      medium: "متوسطة",
      high: "عالية",
      veryLikely: "مرجّح جداً",
      likely: "مرجّح",
      possibly: "محتمل",
      sentence: "{{intent}}: {{likelihood}}",
    },
  },
  actions: {
    hide: "إخفاء",
    unhide: "إظهار",
    done: "منجز",
    reopen: "إعادة فتح",
    assign: "إسناد",
    delete: "حذف",
    hidden: "تم إخفاء التعليق",
    unhidden: "أصبح التعليق ظاهراً",
    markedDone: "تم التمييز كمنجز",
    reopened: "أُعيد فتحه",
    assigned: "أُسند إلى {{name}}",
    unassigned: "أُلغي الإسناد",
    deleted: "تم حذف التعليق",
    failed: "لم ينجح ذلك، وتم التراجع عن التغيير.",
  },
  ai: {
    title: "اقتراحات الذكاء الاصطناعي",
    subtitle: "مكتوبة بصوت علامتك التجارية",
    insert: "استخدم",
    regenerate: "توليد من جديد",
    loading: "جارٍ صياغة الردود…",
    error: "تعذّرت صياغة الاقتراحات",
    shorter: "أقصر",
    formal: "أكثر رسمية",
    english: "بالإنجليزية",
    arabic: "بالعربية",
    custom: "أخبر الذكاء الاصطناعي بما تريد تغييره…",
    suggested: "الرد المقترح",
    others: "اقتراحات أخرى",
    fewer: "عرض أقل",
    rewrite: "أعد صياغته",
  },
  reply: {
    placeholder: "اكتب رداً…",
    placeholderPrivate: "اكتب رسالة خاصة إلى ‎@{{user}}…",
    public: "رد علني",
    private: "رد خاص (رسالة)",
    privateHint: "يرسل رسالة خاصة لصاحب التعليق. يسمح إنستغرام برد خاص واحد لكل تعليق خلال {{days}} أيام.",
    privateUsed: "أُرسل رد خاص لهذا التعليق مسبقاً، ويسمح إنستغرام برد واحد فقط.",
    privateExpired: "الرد الخاص ممكن فقط خلال {{days}} أيام من التعليق.",
    privateUnsupported: "هذه القناة لا تدعم الردود الخاصة.",
    send: "رد",
    sending: "جارٍ الإرسال…",
    sent: "تم إرسال الرد",
    sentPrivate: "تم إرسال الرد الخاص",
    queued: "جارٍ إرسال الرد…",
    counter_zero: "{{count}} / {{max}}",
    counter_one: "{{count}} / {{max}}",
    counter_two: "{{count}} / {{max}}",
    counter_few: "{{count}} / {{max}}",
    counter_many: "{{count}} / {{max}}",
    counter_other: "{{count}} / {{max}}",
    shortcut: "Enter للإرسال · Shift+Enter لسطر جديد",
    tooLong: "أطول من المسموح في إنستغرام",
    sendingUndo: "سيُرسل خلال لحظات…",
    notSent: "لم يُرسل. نصك عاد إلى مربع الكتابة.",
  },
  dm: {
    windowOpen: "نافذة الرد مفتوحة",
    windowLeft: "متبقٍّ {{time}} للرد",
    windowClosingSoon: "تُغلق قريباً: متبقٍّ {{time}}",
    windowClosed: "نافذة الرد مغلقة",
    windowClosedHint: "يسمح إنستغرام للأنشطة التجارية بمراسلة الشخص خلال 24 ساعة فقط من آخر رسالة منه. يمكنك الرد مجدداً حين يكتب {{name}}.",
    windowExplain: "قاعدة الـ24 ساعة في إنستغرام: يمكنك الرد بحرية خلال 24 ساعة من آخر رسالة للعميل.",
    aiAgent: "الوكيل الذكي",
    aiAgentOn: "الوكيل الذكي يرد على هذه المحادثة",
    aiAgentOff: "الوكيل الذكي متوقف: أنت ترد يدوياً",
    aiAgentEnabled: "تم تشغيل الوكيل الذكي",
    aiAgentDisabled: "تم إيقاف الوكيل الذكي",
    placeholder: "راسل {{name}}…",
    send: "إرسال",
    sent: "تم إرسال الرسالة",
    failed: "لم تُرسل الرسالة",
    sentByAi: "ذكاء",
    sentByAutomation: "أتمتة",
    sentByUser: "الفريق",
    transcript: "النص",
    noTranscript: "لا يوجد نص بعد",
    play: "تشغيل الرسالة الصوتية",
    pause: "إيقاف مؤقت",
    quickReplies: "ردود سريعة",
    quickRepliesHint: "أزرار قابلة للنقر تحت رسالتك (حتى {{max}}، كل منها {{len}} حرفاً).",
    buttons: "أزرار",
    buttonsHint: "حتى {{max}} أزرار برابط أو قيمة.",
    addQuickReply: "إضافة رد سريع",
    addButton: "إضافة زر",
    buttonTitle: "عنوان الزر",
    buttonUrl: "https://…",
    quickReplyTitle: "عنوان الرد",
    status: {
      received: "مستلمة",
      sending: "جارٍ الإرسال",
      sent: "أُرسلت",
      delivered: "وصلت",
      read: "شوهدت",
      failed: "فشلت",
    },
    today: "اليوم",
    yesterday: "أمس",
    loadOlder: "تحميل رسائل أقدم",
  },
  contact: {
    title: "الشخص",
    identities: "القنوات",
    tags: "الوسوم",
    noTags: "لا وسوم",
    firstSeen: "أول ظهور",
    lastSeen: "آخر ظهور",
    viewProfile: "فتح الملف",
    show: "إظهار تفاصيل الشخص",
    hide: "إخفاء تفاصيل الشخص",
    personDetails: "تفاصيل الشخص",
    allComments: "كل تعليقاته",
  },
  shortcuts: {
    hint: "الاختصارات",
  },
};
